
import {ActionTypes, CCAxios} from './../../cc-imports'


const Actions = {
    getMatch: (matchId, type)=> {
        return {
            type: ActionTypes.GET_MATCH,
            payload: CCAxios.get('/match/matchId/' + matchId + '/'),
            meta : {
                type : type
            }
        }
    },

    getMatchByKey: (key, type)=> {
        return {
            type: ActionTypes.GET_MATCH,
            payload: CCAxios.get('/match/matchKey/' + key + '/'),
            meta : {
                type : type
            }
        }
    },

    refreshMatch: (matchId, type)=> {
        return {
            type: ActionTypes.REFRESH_MATCH,
            payload: CCAxios.get('/match/matchId/' + matchId + '/'),
            meta : {
                type : type
            }
        }
    },

    getUpComingMatches: (req, type)=> {
        return {
            type: ActionTypes.GET_MATCHES,
            payload: CCAxios.get('/match/status/notstarted/' + req.page + '/' + req.limit + '/'),
            meta : {
                type : type
            }
        }
    },

    getAllUpComingMatches: (req, type)=> {
        return {
            type: ActionTypes.GET_MATCHES,
            payload: CCAxios.get('/match/status/notstarted/' + req.page + '/' + req.limit + '/'),
            meta : {
                type : type
            }
        }
    },
    getLiveMatches: (req, type)=> {
        return {
            type: ActionTypes.GET_MATCHES,
            payload: CCAxios.get('/match/status/started/' + req.page + '/' + req.limit + '/'),
            meta : {
                type : type
            }
        }
    },
    getCompletedMatches: (req, type)=> {
        return {
            type: ActionTypes.GET_MATCHES,
            payload: CCAxios.get('/match/status/completed/' + req.page + '/' + req.limit + '/'),
            meta : {
                type : type
            }
        }
    },
    getRecentMatches: (type) => {
        return {
            type: ActionTypes.GET_MATCHES,
            payload: CCAxios.get('/match/recent/'),
            meta : {
                type : type
            }
        }
    }
};

export default Actions



// WEBPACK FOOTER //
// ./src/app/data/actions/MatchActions.js